import {Chromeless} from '@freckle/classroom/ts/hooks/chromeless/component'
import {LoggedRoute} from '../../logged-route'
import {
  ElaAdaptiveSkillsReportHandler,
  ElaArticleClassActivityHandler,
  ElaArticleReadingAssignmentSessionReportHandler,
  ElaAssessmentAssignmentsReportHandler,
  ElaAssessmentReportHandler,
  ElaAssessmentSessionReportHandler,
  ElaAssignmentSessionHistoryReportHandler,
  ElaCorrelationPage,
  ElaGroupsReportHandler,
  ElaLevelsReportHandler,
  ElaReportCardViewHandler,
  ElaReportCardsHandler,
  ElaSkillsProgressReportHandler,
  ElaStandardStudentReportHandler,
  ElaTargetedSkillsReportHandler,
  ElaFocusSkillsReportHandler,
  ElaFocusSkillsAssignmentReportHandler,
  ElaTargetedSkillsAssignmentReportHandler,
  ElaWordStudyMatrixReportHandler,
  ElaWritingAssignmentReportHandler,
  PerformanceByStandardReportHandler,
  PrintElaReportCardsHandler,
  WordStudySessionReportHandler,
  WordStudyReportHandler
} from './lazy'

export const routerV2ElaReports = [
  {
    path: '/ela/report-cards',
    element: <LoggedRoute component={ElaReportCardsHandler} />
  },
  {
    path: '/ela/report-cards/:studentId',
    element: <LoggedRoute component={ElaReportCardsHandler} />
  },
  {
    path: '/ela/report-card',
    element: <LoggedRoute component={ElaReportCardViewHandler} />
  },
  {
    path: '/ela/print-ela-report-cards',
    element: <LoggedRoute component={PrintElaReportCardsHandler} />
  },
  {
    path: '/ela/reports/assessment/:assignmentId',
    element: <LoggedRoute component={ElaAssessmentReportHandler} />
  },
  {
    path: '/ela/reports/assessment-sessions/:assignmentSessionId',
    element: <LoggedRoute component={ElaAssessmentSessionReportHandler} />
  },
  {
    path: '/ela/reports/performance-by-standard',
    element: <LoggedRoute component={PerformanceByStandardReportHandler} />
  },
  {
    path: '/ela/groups-report',
    element: <LoggedRoute component={ElaGroupsReportHandler} />
  },
  {
    path: '/session-history/ela-article',
    element: <LoggedRoute component={ElaAssignmentSessionHistoryReportHandler} />
  },
  {
    path: '/ela/standards/students/:studentId/report',
    element: <LoggedRoute component={ElaStandardStudentReportHandler} />
  },
  {
    path: '/ela/reports/levels',
    element: <LoggedRoute component={ElaLevelsReportHandler} />
  },
  {
    path: '/ela/reports/assessments',
    element: <LoggedRoute component={ElaAssessmentAssignmentsReportHandler} />
  },
  {
    path: '/ela/word-study-matrix',
    element: <LoggedRoute component={ElaWordStudyMatrixReportHandler} />
  },
  {
    path: '/ela-skills-progress-report',
    element: <LoggedRoute component={ElaSkillsProgressReportHandler} />
  },
  {
    path: '/ela/reports/writing/:assignmentId',
    element: <LoggedRoute component={ElaWritingAssignmentReportHandler} />
  },
  {
    path: '/ela/reports/reading/:assignmentId/students/:studentId',
    element: <LoggedRoute component={ElaArticleReadingAssignmentSessionReportHandler} />
  },
  {
    path: '/ela/reports/adaptive-skills/:assignmentId/students/:studentId',
    element: <LoggedRoute component={ElaAdaptiveSkillsReportHandler} />
  },
  {
    path: '/ela/reports/targeted-skills/:assignmentId/students/:studentId',
    element: <LoggedRoute component={ElaTargetedSkillsReportHandler} />
  },
  {
    path: '/chromeless/ela/reports/targeted-skills/:assignmentId/students/:studentId',
    element: (
      <Chromeless reportSizing>
        <LoggedRoute
          dashboardType="minimal"
          fullScreen
          component={ElaTargetedSkillsReportHandler}
        />
      </Chromeless>
    )
  },
  {
    path: '/ela/reports/focus-skills/:assignmentId/students/:studentId',
    element: <LoggedRoute component={ElaFocusSkillsReportHandler} />
  },
  {
    path: '/reports/ela-focus-skills-practice/:assignmentId',
    element: <LoggedRoute component={ElaFocusSkillsAssignmentReportHandler} />
  },
  {
    path: '/ela/reports/targeted-skills-assignment/:assignmentId',
    element: <LoggedRoute component={ElaTargetedSkillsAssignmentReportHandler} />
  },
  {
    path: '/chromeless/ela/reports/targeted-skills-assignment/:assignmentId',
    element: (
      <Chromeless reportSizing>
        <LoggedRoute
          dashboardType="minimal"
          fullScreen
          component={ElaTargetedSkillsAssignmentReportHandler}
        />
      </Chromeless>
    )
  },
  {
    path: '/ela/reports/word-study/:assignmentId',
    element: <LoggedRoute component={WordStudyReportHandler} />
  },
  {
    path: '/chromeless/ela/reports/word-study/:assignmentId',
    element: (
      <Chromeless reportSizing>
        <LoggedRoute dashboardType="minimal" fullScreen component={WordStudyReportHandler} />
      </Chromeless>
    )
  },
  {
    path: '/ela/reports/word-study/:assignmentSessionId/students/:studentId',
    element: <LoggedRoute component={WordStudySessionReportHandler} />
  },
  {
    path: '/chromeless/ela/reports/word-study/:assignmentSessionId/students/:studentId',
    element: (
      <Chromeless reportSizing>
        <LoggedRoute dashboardType="minimal" fullScreen component={WordStudySessionReportHandler} />
      </Chromeless>
    )
  },
  {
    path: '/session-history/ela-article/:articleUuid',
    element: <LoggedRoute component={ElaArticleClassActivityHandler} />
  },
  {
    path: '/ela/correlation',
    element: <LoggedRoute component={ElaCorrelationPage} />
  }
]
